<template>
  <div class="card-radio-offre">
    <label :for="this.paiementId">
      <div
        :class="[
          'card-paiement',
          this.activePaiement === this.paiementId ? 'is-active' : ''
        ]"
      >
        <div class="card-content">
          {{ this.paiementTitre }}
          <div class="categories-paiement mt-2">
            <div
              class="categorie-paiement"
              v-for="paiement of this.paiementListe"
              :key="paiement.index"
            >
              <img :src="require('@/assets/' + paiement + '.png')" /><br />
              {{ ("libelle_" + paiement) | translate(locale) }}
            </div>
          </div>
        </div>
      </div>
    </label>
    <input
      type="radio"
      :id="this.paiementId"
      name="paiement"
      @change="updateActivePaiement"
      :checked="this.activePaiement === this.paiementId"
    />
  </div>
</template>

<script>
import translations from "@/Translations.js";

export default {
  props: {
    paiementId: String,
    paiementTitre: String,
    paiementListe: undefined,
    activePaiement: String,
    locale: {
      type: String,
      default: "fr"
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    updateActivePaiement() {
      this.$emit("onUpdatePaiement", this.paiementId);
    }
  }
};
</script>

<style>
.is-active {
  border: 1px solid #003690 !important;
}

.categorie-paiement {
  margin: 10px 5px;
  max-width: 80px;
}

.categories-paiement {
  display: inline-flex;
  flex-wrap: wrap;
}

.card-radio-paiement .card-body {
  padding: 1.25rem 1rem;
}

.card-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

/* mobile phone */
@media (max-width: 480px) {
  .card-content {
    font-size: 14px;
  }
}
</style>
